import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        accessToken: undefined,
        selectedNpi: undefined,
        permissions: [],
    },
    reducers: {
        setNpi(state, action) {
            const { accessToken, selectedNpi, permissions } = action.payload;
            return {
                ...state,
                accessToken,
                selectedNpi,
                permissions,
            };
        },
    },
});

export const { setNpi } = authSlice.actions;
